import { select } from 'redux-saga/effects';

// Our worker Saga that logins the user
export function* startupApp(api) {
  const state = yield select();
  const token = state.loginReducer.token;
  return api.setAuthorization(token);
}
